import {GalleryGridItemType} from '../../../../constants';
import {GalleryGridItem, IPromotion, IProduct, LoadMoreType} from '../../../../types/galleryTypes';

interface GetGridItemsParams {
  firstVisiblePage: number;
  numberOfVisibleProducts: number;
  products: IProduct[];
  promotions: IPromotion[];
  loadMoreType: LoadMoreType;
  maxProductsPerPage: number;
  currentPage: number;
  hasSelectedFilters: boolean;
}

export function getGridItems({
  firstVisiblePage,
  numberOfVisibleProducts,
  products,
  promotions,
  loadMoreType,
  maxProductsPerPage,
  currentPage,
  hasSelectedFilters,
}: GetGridItemsParams): GalleryGridItem[] {
  let startOfCurrentPageItem = 0;

  if (loadMoreType !== LoadMoreType.PAGINATION) {
    startOfCurrentPageItem = maxProductsPerPage * (firstVisiblePage - 1);
  }

  const nextProducts = products.slice(startOfCurrentPageItem, numberOfVisibleProducts);
  const productsStartIndex =
    loadMoreType === LoadMoreType.PAGINATION ? maxProductsPerPage * (currentPage - 1) : startOfCurrentPageItem;

  const items: GalleryGridItem[] = nextProducts.map((product) => ({
    type: GalleryGridItemType.Product,
    data: product,
  }));
  const visibleProductsCount = nextProducts.length;

  if (hasSelectedFilters || promotions.length === 0) {
    return items;
  }

  for (const promotion of promotions) {
    const localPosition = promotion.position - productsStartIndex;
    if (localPosition <= 0) {
      continue;
    }

    const insertAt = localPosition - 1;
    if (insertAt < visibleProductsCount) {
      items.splice(insertAt, 0, {type: GalleryGridItemType.Promotion, data: promotion});
    }
  }

  return items;
}
